import { Observable } from 'rxjs'
import { environment } from 'src/environments/environment'

import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'

@Injectable()
export class OrganizationRequiredSubscriptionService {
  constructor(private http: HttpClient) {}

  public createOne(
    organizationId: number,
    subscriptionId: number
  ): Observable<boolean> {
    return this.http.post<any>(
      `${environment.backendApiUrl}/organizations/${organizationId}/required-subscriptions`,
      { subscriptionId, organizationId }
    )
  }

  public deleteOne(
    organizationId: number,
    requiredsubscriptionId: number
  ): Observable<boolean> {
    return this.http.delete<any>(
      `${environment.backendApiUrl}/organizations/${organizationId}/required-subscriptions/${requiredsubscriptionId}`
    )
  }
}
